import lazyLoading from "./lazyLoading";

export default {
  name: "settings",
  meta: {
    icon: "fa-gear",
    expanded: false,
    label: "Configuration"
  },

  children: [
    {
      name: "ofp-settings",
      path: "/admin/settings/ofp",
      meta: {
        title: "Dates ofp",
        label: "Dates ofp"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/OfpDates")
    },
    {
      name: "reminder-settings",
      path: "/admin/settings/relances",
      meta: {
        title: "Dates primes",
        label: "Dates primes"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/ReminderDates")
    },
    {
      name: "notification-settings",
      path: "/admin/settings/notifications",
      meta: {
        title: "Notifications",
        label: "Notifications"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/Notifications")
    },
    {
      name: "scholaryear-settings",
      path: "/admin/settings/scholaryear",
      meta: {
        title: "Année scolaire",
        label: "Année scolaire"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/ScholarYear")
    },
    {
      name: "interview-settings",
      path: "/admin/settings/interview",
      meta: {
        title: "Entretien diagnostic",
        label: "Entretien diagnostic"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/InterviewForm")
    },
    {
      name: "booking-settings",
      path: "/admin/settings/booking",
      meta: {
        title: "Réservation d'entretien",
        label: "Réservation d'entretien"
        //isAdminStaff: true,
      },
      component: lazyLoading("settings/BookingSettings")
    },
  ]
};
